<h2 class="mat-h2">{{ title }}</h2>
<p class="mat-body-2">{{ description }}</p>
<span class="mat-caption">{{ hint }}</span>

<div class="actions">

    <div class="cancel">
        <button mat-button
                mat-stroked-button
                id="delete-dialog-cancel"
                (click)="cancel()">
            {{ 'default.cancel' | blah | uppercase }}
        </button>
    </div>
    <div class="delete">
        <button mat-button
                mat-flat-button
                color="warn"
                id="delete-dialog-delete"
                [type]="'raised'"
                (click)="delete()">
            {{ 'default.delete' | blah | uppercase }}
        </button>
    </div>
</div>